var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upgrade-stepper-component" },
    [
      _c(
        "KmModal",
        {
          attrs: { maxWidth: "700", persistent: "", noClickAnimation: "" },
          model: {
            value: _vm.model,
            callback: function($$v) {
              _vm.model = $$v
            },
            expression: "model"
          }
        },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _c("VScrollXReverseTransition", { attrs: { mode: "out-in" } }, [
                _c(
                  "div",
                  { key: _vm.currentStep },
                  [
                    _vm.currentStep === _vm.STEP_FROM_PLUS_PLAN_WARNING
                      ? [
                          _c("span", { staticClass: "warning--text" }, [
                            _vm._v("\n              Warning\n            ")
                          ])
                        ]
                      : _vm.currentStep === _vm.STEP_CHURN
                      ? [
                          _vm._v(
                            "\n            Your feedback on PM2 Plus\n          "
                          )
                        ]
                      : _vm.currentStep === _vm.STEP_CARD
                      ? [_vm._v("\n            Add a card\n          ")]
                      : _vm.currentStep === _vm.STEP_FINAL
                      ? [_vm._v("\n            Confirmation\n          ")]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasInfos === true
            ? [
                _c("VScrollXReverseTransition", { attrs: { mode: "out-in" } }, [
                  _c(
                    "div",
                    { key: _vm.currentStep, staticClass: "pa-3" },
                    [
                      _vm.currentStep === _vm.STEP_FROM_PLUS_PLAN_WARNING
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n              You are currently subscribed to a legacy plan. You will lose a few features by\n              switching to this new plan:\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ul", { staticClass: "feature-list" }, [
                              _c("li", [_vm._v("Profiling")]),
                              _vm._v(" "),
                              _c("li", [_vm._v("Transaction Tracing")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-row" },
                              [
                                _c("VSpacer"),
                                _vm._v(" "),
                                _c(
                                  "VBtn",
                                  {
                                    staticClass: "contrast warning--text ma-0",
                                    on: { click: _vm.goToNextStep }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Continue\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        : _vm.currentStep === _vm.STEP_CHURN
                        ? [
                            _c("ChurnForm", {
                              on: { submit: _vm.onChurnSubmit }
                            })
                          ]
                        : _vm.currentStep === _vm.STEP_CARD
                        ? [
                            _c("AddCardForm", {
                              attrs: {
                                inUpgradeProcess: "",
                                handleAddCard: _vm.addCard
                              }
                            })
                          ]
                        : _vm.currentStep === _vm.STEP_FINAL
                        ? [
                            !_vm.upgraded
                              ? [
                                  !_vm.isTrial &&
                                  _vm.plan.is_premium &&
                                  _vm.iHaveACoupon
                                    ? [
                                        _c("VTextField", {
                                          attrs: {
                                            name: "coupon",
                                            label: "Coupon Code",
                                            errorMessages: _vm.validCoupon
                                          },
                                          model: {
                                            value: _vm.couponText,
                                            callback: function($$v) {
                                              _vm.couponText = $$v
                                            },
                                            expression: "couponText"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.coupon.id
                                          ? _c(
                                              "h2",
                                              { staticClass: "subheading" },
                                              [
                                                _vm._v(
                                                  "\n                  Coupon applied\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("BillingCoupon", {
                                    attrs: {
                                      plan: _vm.plan,
                                      isTrial: _vm.isTrial,
                                      coupon: _vm.coupon,
                                      loading: _vm.purchaseLoading
                                    },
                                    on: {
                                      close: _vm.closePopup,
                                      submit: _vm.purchase
                                    }
                                  })
                                ]
                              : [
                                  _vm.isPremiumUpgrade
                                    ? _c("h2", [
                                        _vm._v(
                                          "\n                Congratulation!"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                You now benefit from a premium PM2 subscription."
                                        ),
                                        _c("br"),
                                        _c("br"),
                                        _vm._v(
                                          "\n                We are migrating your current bucket to a more powerful server. It will take up to 1 minutes"
                                        ),
                                        _c("br")
                                      ])
                                    : _vm.isPremiumDowngrade
                                    ? _c("h2", [
                                        _vm._v(
                                          "\n                Your subscription has been cancelled.\n              "
                                        )
                                      ])
                                    : _c("h2", [
                                        _vm._v(
                                          "Your bucket has been " +
                                            _vm._s(
                                              _vm.isDowngrade
                                                ? "downgraded"
                                                : "upgraded"
                                            ) +
                                            "."
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _vm.isPremiumUpgrade || _vm.isPremiumDowngrade
                                    ? _c("h2", [
                                        _vm._v(
                                          "\n                Your bucket is being moved to an other infrastructure. It might take up to 1\n                minute to get data from your app & servers.\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "VBtn",
                                    {
                                      staticClass: "button-reload",
                                      attrs: { color: "primary" },
                                      on: { click: _vm.handleBack }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Next\n              "
                                      )
                                    ]
                                  )
                                ]
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]
            : _c(
                "div",
                { staticClass: "loader pa-4" },
                [
                  _c("VProgressCircular", {
                    attrs: { size: 50, color: "primary", indeterminate: "" }
                  })
                ],
                1
              )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }